import Exception from "core/exceptions/Exception";
import DefaultExceptionTypes from "core/exceptions/DefaultExceptionTypes";
import CustomersRepository from "@/core/customers/repositories/CustomersRepository";
import { CustomersResponse } from "@/core/customers/entities/Customers";

export default class GetCustomersUseCase {
  constructor(private readonly customersRepository: CustomersRepository) {}

  /**
   * Executes the get customers use case.
   *
   * @param name - Filter by customer name
   * @param agency - Filter by agency
   * @param segment - Filter by segment
   * @param riskLevel - Filter by riskLevel level
   * @param kyc - Filter by kyc
   * @param rm - Filter by rm
   * @param page - Page number
   * @param size - Page size
   * @returns A promise resolving with an array of CustomerData
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(
    name: string = "",
    segment: string = "",
    agency: string = "",
    riskLevel: string = "",
    kyc: string = "",
    rm: string = "",
    page: number = 0,
    size: number = 10
  ): Promise<CustomersResponse> {
    try {
      return await this.customersRepository.getCustomers({
        name,
        segment,
        agency,
        riskLevel,
        kyc,
        rm,
        page,
        size,
      });
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}
